import { AutoCompleteItem } from 'types/api/Common/AutoCompleteTypes';
import { DataTypeItem, RuleTypeItem } from 'types/api/SystemTenant/AROKMS/TableDefinitionTypes';

export type TableDefinitionKind = 'associated-attribute' | 'associated-subject';
export type TableDefinitionEditorMode = 'create' | 'edit';

export interface RuleParameterOption extends AutoCompleteItem {
  persistentName?: string | null;
  dataType?: string | null;
  type?: string;
}

export type RuleParameterValue = RuleParameterOption | string | number | boolean | null | undefined;
export type RuleParameterValues = Record<string, RuleParameterValue>;

export interface RuleParameterSchemaItem {
  label: string;
  id: string;
  type: string;
  optionsSource: string | null;
  required?: boolean;
  removeTrim?: boolean;
  defaultValue?: RuleParameterValue;
  inline?: boolean;
  placeholder?: string;
  validationType?: string;
  validations?: Array<{ type: string; params: unknown[] }>;
  ruleTypeCode?: string;
  allowEmpty?: boolean;
  customRegex?: string;
  customRegexErrorMessage?: string;
}

export interface FieldValidationValues {
  validationPattern: string | null;
  minCharacter: number | null;
  maxCharacter: number | null;
  noSpace: boolean;
  noSpecialCharacter: boolean;
}

export interface TableDefinitionEditorValues {
  attribute: RuleParameterOption | null;
  dataType: DataTypeItem | null;
  associatedSubject: RuleParameterOption | null;
  displayName: string;
  ruleType: RuleTypeItem | null;
  ktreeDefinition: RuleParameterOption | null;
  inferenceKTreeDefinition: RuleParameterOption | null;
  allowEmpty: boolean;
  parameters: RuleParameterValues;
  validation: FieldValidationValues;
}

export const EMPTY_FIELD_VALIDATION: FieldValidationValues = {
  validationPattern: null,
  minCharacter: null,
  maxCharacter: 255,
  noSpace: false,
  noSpecialCharacter: false,
};
